const ONGOING_EVENT = 'in_progress'
const COMPLETED = 'completed'
const CANCELLED = 'cancelled'
const FAILED = 'failed'
const STOPPED = 'stopped'
const SCHEDULING = 'scheduling'
const OPTEDOUT = 'OPTEDOUT'
const DELETED = 'deleted'
const ONGOING_EVENT_COLOR = '#EDCD1A'
const NOT_ONGOING_EVENT_COLOR = '#0438E3'
const COMPLETED_EVENT_COLOR = '#7ACF38'
const CANCELLED_EVENT_COLOR = '#929699'
const FAILED_EVENT_COLOR = '#D82424'
const DELETED_EVENT_COLOR = '#D82424'
const SCHEDULINGCOLOR = '#FC943C'
const OPTEDOUTCOLOR = '#929699'

export {
  ONGOING_EVENT,
  ONGOING_EVENT_COLOR,
  NOT_ONGOING_EVENT_COLOR,
  COMPLETED,
  CANCELLED,
  FAILED,
  STOPPED,
  SCHEDULING,
  OPTEDOUT,
  DELETED,
  COMPLETED_EVENT_COLOR,
  CANCELLED_EVENT_COLOR,
  FAILED_EVENT_COLOR,
  DELETED_EVENT_COLOR,
  SCHEDULINGCOLOR,
  OPTEDOUTCOLOR
}
